import { motion } from "framer-motion";

const DATA_SOURCES = ["Sales", "Finance", "Customers", "Staff", "Operations", "Inventory", "Projects"];
const IMG = "/ops-photo-owner-laptop.png";

export default function OpsDataInsight() {
  return (
    <section data-testid="section-data-insight" className="relative bg-[#F1ECE0] text-[#1A2E4A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#1A2E4A] mb-6 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#B8E024]" />
              The problem
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-editorial text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A2E4A]">
              Every business has data.
              <br />
              <span className="italic">Every leader needs insight.</span>
            </motion.h2>

            <div className="mt-8">
              <p className="text-base md:text-lg text-[#1A2E4A]/75 leading-relaxed mb-4">Every business generates data.</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {DATA_SOURCES.map((d, i) => (
                  <motion.span key={d}
                    initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                    transition={{ delay: i * 0.06 }}
                    data-testid={`data-source-${d.toLowerCase()}`}
                    className="inline-flex items-center gap-2 px-3.5 py-2 border border-[#1A2E4A]/25 bg-white text-sm text-[#1A2E4A]"
                  >
                    <span className="inline-block h-1 w-1 rounded-full bg-[#B8E024]" /> {d}
                  </motion.span>
                ))}
              </div>
            </div>

            <div className="mt-8 space-y-4 max-w-xl">
              <p className="font-editorial text-2xl md:text-3xl leading-tight text-[#1A2E4A]">
                The challenge isn&apos;t collecting information.
                <br />
                <span className="italic">The challenge is knowing what it means.</span>
              </p>
              <p className="text-base text-[#1A2E4A]/75 leading-relaxed">
                OpsIQ transforms everyday business data into meaningful insights that help
                organisations improve performance, strengthen accountability, and make better decisions.
              </p>
            </div>
          </div>

          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6"
          >
            <div className="relative overflow-hidden border border-[#1A2E4A]/15">
              <img
                src={IMG}
                alt="Ghanaian business owner reviewing dashboard on a laptop"
                data-testid="data-insight-image"
                className="w-full h-[420px] md:h-[540px] object-cover"
              />
              <div className="absolute top-4 left-4 bg-[#142645] text-[#F1ECE0] px-3 py-1.5 text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold">
                Small business · Kumasi
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
